import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-8 px-6" data-id="element-113">
      <div className="max-w-4xl mx-auto" data-id="element-114">
        <p className="text-white/40 text-xs md:text-sm leading-relaxed" data-id="element-115">
          <strong className="text-white/55 font-semibold" data-id="element-116">AVISO LEGAL:</strong>{' '}
          Este sitio y el manual "El Envés del Metabolismo" proporcionan
          información educativa sobre bio-optimización. No sustituyen el
          consejo, diagnóstico o tratamiento médico profesional. El protocolo de
          72 horas y el uso de suplementos opcionales deben ser supervisados por
          un profesional de la salud, especialmente en personas con condiciones
          preexistentes como diabetes tipo 1 o 2. El autor no se responsabiliza
          por el mal uso de la información técnica aquí descrita.
        </p>
        <div className="mt-6 pt-4 border-t border-white/10 text-center" data-id="element-117">
          <p className="text-white/30 text-xs" data-id="element-118">
            © {new Date().getFullYear()} El Envés del Metabolismo. Todos los
            derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}